import React, { Component } from "react";
import {
  Badge,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  ListGroup,
  ListGroupItem,
  Row,
  TabPane,
  TabContent,
  InputGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
  CustomInput,
  Spinner
} from "reactstrap";
import Message from "./Message";
import CreatableSelect from "react-select/lib/Creatable";
import { ButtonWithAuth } from "../../../authComponents/authComponents";

import './ConversationDetails.scss';
import {validate} from '../../../utils/validation'

const moment = require("moment-timezone");
const apiCalls = require("../../../ApiCalls");
const webOn = require("../../Icons/custom_icons/WEBCHAT_ACTIVE.png")
const voiceOn = require("../../Icons/custom_icons/PHONE_ACTIVE.png")
const iosOn = require("../../Icons/custom_icons/IOS_APP_ACTIVE.png")
const fbOn = require("../../Icons/custom_icons/FB_ACTIVE.png")
const dashOn = require("../../Icons/custom_icons/DASHCHAT_ACTIVE.png")
const smsOn = require("../../Icons/custom_icons/SMS_APP_ACTIVE.png")

class ConversationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      splitButtonOpen: false,
      conversationTags: [],
      modal: false,
      newTag: null,
      options: [],
      userId: null,
      comment: "",
      conversationId: null,
      hide: true,
      audioURL: null,
      modal2: false,
      issueCreated: false,
      createIssueDisabled: false,
      time: "",
      issueSeverity: "Minor",
      issueSummary: "",
      issueDescription: "",
      hideEmptyIssueSummaryWarning: true,
      hideLongIssueSummaryWarning: true,
      hideEmptyIssueEmailAddressWarning: true,
      copyConversationURL: false,
      getNonRedacted: false,
      copyConversationDialogue: false,
      pendingAudio: false,
      isPartialsHidden: true,
      loadingAudio: false,
      isSpanishLanguage: false,
      linkedConversations: [],
      hasLinkedConversation: false,
      isParentLink: true,
      loading: true

    };
    this.getTagsPerConversation = this.getTagsPerConversation.bind(this);
    this.getIndex = this.getIndex.bind(this);
    this.createNewtag = this.createNewtag.bind(this);
    this.addTagToConversation = this.addTagToConversation.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.getTags = this.getTags.bind(this);
    this.deleteTagAttempt = this.deleteTagAttempt.bind(this);
    this.handleTagSelect = this.handleTagSelect.bind(this);
    this.submitComment = this.submitComment.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleTagInput = this.handleTagInput.bind(this)
    this.getDuration = this.getDuration.bind(this)
    this.getLanguage = this.getLanguage.bind(this)
    this.getConversationAudio = this.getConversationAudio.bind(this);
    this.createIssue = this.createIssue.bind(this);
    this.toggleModal2 = this.toggleModal2.bind(this);
    this.handleSeveritySelect = this.handleSeveritySelect.bind(this);
    this.handleSummaryChange = this.handleSummaryChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.copyConversationDialogue = this.copyConversationDialogue.bind(this);
    this.toggleCopyTooltips = this.toggleCopyTooltips.bind(this);
    this.getNonRedacted = this.getNonRedacted.bind(this)
    this.generateUnredactedLink = this.generateUnredactedLink.bind(this)
    this.togglePartials = this.togglePartials.bind(this);
    this.getChannelIcon = this.getChannelIcon.bind(this);
    this.toggleSpanishLanguage = this.toggleSpanishLanguage.bind(this);
    this.openIssuePermitted = this.openIssuePermitted.bind(this);
    this.generateLinkedConversations = this.generateLinkedConversations.bind(this)
    this.getLinkedConversations = this.getLinkedConversations.bind(this)
    this.redirectConversation = this.redirectConversation.bind(this)

  }


  componentDidMount(){
    this.getLinkedConversations();
    this.getMetaDataRows();
    this.props.getTags();
    this.getTagsPerConversation();
    this.getConversationAudio();
    this.getOptions();
    this.getTags();
  }

  componentDidUpdate(prevProps){
    if (this.props.selectedConversation !== prevProps.selectedConversation) {
      this.getLinkedConversations()
      this.getMetaDataRows()
      this.getTagsPerConversation();
      this.getConversationAudio();
      this.getOptions();
      this.getTags();
      this.setState({
        isSpanishLanguage: false
      });
    }
  }

  getSeverityOptions() {
    const SEVERITYLIST = ["Critical", "Major", "Minor", "Trivial"];
    return SEVERITYLIST.map((state, index) => {
      return (
        <option key={index} value={state}>{state}</option>
      );
    });
  }

  generateAudioFileName = (conversationObject) =>{
    let startDate = moment.tz(parseInt(conversationObject.startTime), this.props.settings.timezone).format("MM.DD.YY_hhmmss")
    let nameSpace = window.location.hostname
    let conversationId = conversationObject.conversationId
    return `${nameSpace}_${startDate}_${conversationId}.wav`
  }

  getConversationAudio()
  {
    if(this.props.selectedConversation && this.props.channelName.toLowerCase().includes('voice'))
    {
      this.setState({loadingAudio: true, pendingAudio: false})
      if(this.props.settings.audioStorage === 'prism')
      {
        apiCalls.getPrismMetadata(this.props.selectedConversation.conversationId).then((res)=>{
          this.setState({loadingAudio: false})
          if(res.data)
          {
            let audioUrl = res.data.url[0]._text
            if(apiCalls.getApiUrl().toLowerCase().includes('sit'))
            {
              let selUrl = res.data.url.filter(val=>val._text.includes('b.vail/'))
              audioUrl = selUrl.length > 0 ? selUrl[0]._text : res.data.url[0]._text
            }
            let streamURL = `${apiCalls.getApiUrl()}/prism/stream?url=${audioUrl}&fileName=${this.generateAudioFileName(this.props.selectedConversation)}`
            this.setState({audioURL: streamURL, pendingAudio: false})
          }
          else{
            this.setState({audioURL: null, pendingAudio: true, loadingAudio: false})
          }
        }).catch((err)=>{
            this.setState({audioURL: null, pendingAudio: true, loadingAudio: false})
        })
      }
      else{
        this.setState({audioURL: this.getVoiceRecordingUrl(), pendingAudio: false, loadingAudio: false})
      }
    }
  }

  getDuration()
  {
    if(this.props.selectedConversation.endTime)
    {
      let elapsed = this.props.selectedConversation.endTime - this.props.selectedConversation.startTime

      let hour = Number.parseInt( Math.floor(elapsed / 3600000));
      let hrString = hour > 0 ? `${hour} hours` : ``
      let min = Number.parseInt( Math.floor((elapsed - hour * 3600000) / 60000));
      let minString = min > 0 ? `${min} minutes` : ``
      let sec = Number.parseInt( Math.floor((elapsed - hour * 3600000 - min * 60000) / 1000));
      let secString = `${sec} seconds`

      return `${hrString} ${minString} ${secString}`
    }
    else{
      return `In progress`
    }
  }

  getVoiceRecordingUrl() {
    if (
      this.props.selectedConversation &&
      this.props.selectedConversation.conversationId
    ) {
      var cacheBreak = new Date().valueOf();
      return `${apiCalls.getApiUrl()}/conversations/${this.props.selectedConversation.conversationId}/recording?cacheBreak=${cacheBreak}`;
    } else {
      return null;
    }
  }

  getRatingIcon() {
    if (
      this.props.selectedConversation &&
      this.props.selectedConversation.errors > 2
    ) {
      return (
        <i
          className="cui-thumb-down icons font-2xl"
        />
      );
    } else {
      return (
        <i
          className="cui-thumb-up icons font-2xl"
        />
      );
    }
  }

  getChannelIcon(channelName) {
    let icon;
    if (channelName.includes("OMNI_VOICE")) icon = voiceOn;
    else if (channelName.includes("OMNI_WEBCHAT")) icon = webOn;
    else if (channelName.includes("OMNI_IOSAPP")) icon = iosOn;
    else if (channelName.includes("OMNI_DASHCHAT")) icon = dashOn;
    else if (channelName.includes("OMNI_FACEBOOK")) icon = fbOn;
    else if (channelName.includes("OMNI_SMS")) icon = smsOn;
    else icon = "";
    return icon;
  }

  getBadgeColor(errorCount) {
    if (errorCount < 1) {
      return "success";
    }
    else {
      return "warning";
    }
  }

  getSuccessStats() {
    let activitiesStarted = [], activitiesCompleted = [], surveyScore;

    if (this.props.messagesData) {
      for (var message of this.props.messagesData) {
        if (message.agent === 'system') {
          let parts = message.message.split('|')
          if (parts.length < 2) { continue }
          let activityName = parts[1].startsWith("TT_") ? parts[1].slice(3) : parts[1]
          if (parts[0].startsWith("IVR_SURVEY_SUCCESS") && (!surveyScore && surveyScore !== 0)) surveyScore = parseInt(parts[1]);
          else if (parts[0].startsWith("IVR_SURVEY_SUCCESS") && (surveyScore || surveyScore === 0)) surveyScore += parseInt(parts[1]);
          switch (parts[0]) {
            case 'START_ACTIVITY':
              activitiesStarted.push(activityName)
              break
            case 'END_ACTIVITY_SUCCESS':
              activitiesCompleted.push(activityName)
              break
            default:
              break
          }
        }
      }
    }

    return <div>
      <Row><Col><h6 className="conversation-detail">Success Rate: {activitiesStarted.length === 0 ? 0.00 : (activitiesCompleted.length * 100 / activitiesStarted.length).toFixed(0)}%</h6></Col></Row>
      <Row><Col><h6 className="conversation-detail">Completed Ratio: {this.props.formatCount(activitiesCompleted.length)} of {this.props.formatCount(activitiesStarted.length)}</h6></Col></Row>
      <Row><Col><h6 className="conversation-detail">Activities Started: {activitiesStarted.join(', ')}</h6></Col></Row>
      <Row><Col><h6 className="conversation-detail">Activities Completed: {activitiesCompleted.join(', ')}</h6></Col></Row>
      <Row><Col><h6 className="conversation-detail">Survey score: {surveyScore}</h6></Col></Row>
    </div>
  }

  submitComment() {
    if (this.state.comment) {
      return apiCalls.addComment(this.props.selectedConversation.conversationId, this.state.comment)
        .then(result => {
          if (result) {
            this.setState({
              hide: true
            });
          }
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
    }
    else {
      return apiCalls.deleteComment(this.props.selectedConversation.conversationId)
        .then(result => {
          if (result) {
            this.setState({
              hide: true
            });
          }
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
    }
  }

  toggleModal2() {
    let currentDate = new Date();
    const time = (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear() + " " + currentDate.getHours() + ":" + ("0" + currentDate.getMinutes()).slice(-2);
    this.setState({
      modal2: !this.state.modal2,
      issueCreated: false,
      createIssueDisabled: false,
      time: time,
      issueSeverity: "Minor",
      issueSummary: "",
      issueDescription: "",
      hideEmptyIssueSummaryWarning: true,
      hideLongIssueSummaryWarning: true,
      hideEmptyIssueEmailAddressWarning: this.props.settings.issue_email_address ? true : false
    });
  }

  handleChange(event)
  {
    this.setState({comment: event.target.value})
    this.setState({hide: false})

  }

  handleKeyPress(event) {
     if (event.key === "Enter") {
      this.setState({
        comment: event.target.value,
        hide: true
      })
      this.submitComment()
     }
  }

  handleTagInput(event) {
    if (event.replace(/\s|'/g, "").replace(/[^\w\s]|_/g, "").length > 0) {
      this.getOptions();
    }
  }

  handleSeveritySelect(event) {
    const SEVERITY = event.target.value;
    this.setState({
      issueSeverity: SEVERITY
    });
  }

  handleSummaryChange(event) {
    const SUMMARY = event.target.value;
    if (SUMMARY.length > 100) {
      this.setState({
        hideLongIssueSummaryWarning: false
      });
    }
    else {
      this.setState({
        issueSummary: SUMMARY,
        hideEmptyIssueSummaryWarning: true,
        hideLongIssueSummaryWarning: true
      });
    }
  }

  handleDescriptionChange(event) {
    const DESCRIPTION = event.target.value;
    this.setState({
      issueDescription: DESCRIPTION
    });
  }

  toggleCopyTooltips(event) {
    this.setState({
      [event.target.id]: true
    }, () => {
      window.setTimeout(() => {
        this.setState({ [event.target.id]: false })
      }, 1000);
    });
  }

  getLanguage()
  {
    return this.props.selectedConversation.language ? this.props.selectedConversation.language : "English"
  }

  getNonRedacted()
  {
    this.props.displayToast("Getting unredacted audio, please wait.", "warn")
    apiCalls.getPrismMetadataUnredacted(this.props.selectedConversation.conversationId, null).then((res)=>{
      if(res.data){
        navigator.clipboard.writeText(res.data.url._text)
      }
      else{
        this.props.displayToast(`Unredacted audio not available`, "error");
      }
    })
  }

  generateUnredactedLink() {
    if (!this.state.pendingAudio && (this.props.user.role === "admin" || this.props.user.role === "designer")) {
      return null;
      // FIX AIMED FOR RELEASE 3.16.0
      // return (
      //   <div className="unredacted-link">
      //     <Button
      //       id="getNonRedacted"
      //       color="primary"
      //       className="options-button"
      //       onClick={this.getNonRedacted}
      //     >
      //       Copy Unredacted Audio
      //     </Button>
      //     <Tooltip target="getNonRedacted" trigger="click" isOpen={this.state.getNonRedacted} toggle={this.toggleCopyTooltips}>
      //       Copied!
      //     </Tooltip>
      //   </div>
      // )
    }
  }

  openIssuePermitted(){
    return validate(this.props?.user?.role, ["admin", "designer", "analyst"])
  }

  getLinkedConversations() {

    if (this.props.selectedConversation?.conversationId) {
        this.setState({ loading: true });
        apiCalls.getConversationTransfer(this.props.selectedConversation.conversationId).then((res) => {
          let hasLinks = res.results.length > 0 
          let isParentLink = hasLinks && res.results[0].conversationId === res.results[0].parent_conversation_id
            this.setState({ linkedConversations: res.results, isParentLink: isParentLink, hasLinkedConversation: hasLinks, loading: false })
        })
    }
  }

  redirectConversation(e){
    this.props.getConversationById(e.conversationId)
  }

  generateLinkedConversations() {
    if (this.state.loading) {
      return(
      <div>
        <Spinner color="info" />
      </div>)
    }
    return (this.state.linkedConversations.map((cId, i) => {

      const date = new Date(parseInt(cId.startTime));

      const timeString = date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: true,
        timeZone: 'America/New_York'
      });

      return (
        <Row key={i}>
          <Col>
            <div className='clickable' onClick={() => this.redirectConversation(cId)} value={cId.conversationId}> 
              <p className="conversation-link">{cId.conversationId} - {timeString} </p>
            </div>
          </Col>
        </Row>
      );
    }));
  };



  generateLinkedConversationTitle() {
    if (this.state.hasLinkedConversation || this.state.loading) {
      let title = this.state.isParentLink ? `Parent Conversations`: `Transferred Conversations`
      return <div><Row><Col><p>{title}</p> </Col></Row></div>
    }
  }


  getMetaDataRows() {
    if (this.props.selectedConversation?.conversationId ) {
      var isVoice = this.props.channelName.toLowerCase().includes("voice");
      let canDownload = !this.props.settings.downloadRecording ? "nodownload" : "download"
      if(this.props.selectedConversation.conversationId !== this.state.conversationId || this.state.issueCreated)
      {
        apiCalls.getComments(this.props.selectedConversation.conversationId).then((res)=>{
          if(res.results.length>0){
            this.setState({
                comment: res.results[0].comment,
                conversationId: this.props.selectedConversation.conversationId,
                hide: true
              })
          }
          else{
            this.setState({
              comment: "",
              conversationId: this.props.selectedConversation.conversationId,
              hide: true
            })
          }
          this.setState({
            issueCreated: false
          });
        })
        .catch(err => {
          this.props.handleAPIError(err);
        })
      }
      return [
        <ListGroupItem key="1" className="px-2">
          <Row className="top-row-margin">
            <Col sm={{ span: 4 }}>
              <h6 className="conversation-id-header">
                {"Conversation Id: " + this.props.selectedConversation.conversationId}
              </h6>
            </Col>
            <Col sm="0" lg="1"/>
            <Col>
              <h6 className="channel-header">
                {"Channel: "}
                <img alt="" src={this.getChannelIcon(this.props.channelName)} className="channel-header-img"/>
              </h6>  
            </Col>
            <Col>
              <h6 className="language-header">Language: {this.getLanguage()}</h6>
            </Col>
          </Row>
        </ListGroupItem>,
        <ListGroupItem key="6" className="px-2 audio-group-item" hidden={!isVoice}>
          {this.props.user.role !== "viewer" &&
            <Row>
              <Col xs="2">
                <h6 className="metadata-heading">
                  Audio:
                </h6>
              </Col>
              <Col xs="9" className="no-padding-left">
                <audio
                  controls
                  key={this.state.audioURL}
                  controlsList={canDownload}
                  className="player player-width"
                  preload="none"
                  ref="audio"
                >
                  <source src={this.state.audioURL}/>

                </audio>
               
               {/* Display download option for firefox */}
                {typeof InstallTrigger !== 'undefined' && this.state.audioURL ? <a href={this.state.audioURL}>download</a> : <></>}
                
                <p className="audio-error" hidden={!this.state.pendingAudio}> Failed to retrieve audio, try again later</p>
                <p className="audio-loading" hidden={!this.state.loadingAudio}> Loading...</p>
              </Col>
            </Row>
          }
        </ListGroupItem>,
        <ListGroupItem key="2" className="px-2">
          <Row>
            <Col>
              <h6>Duration: {this.getDuration()}</h6>
            </Col>
            <Col md="auto"></Col>
            <Col>
              <h6 className="float-right">Start Time: {moment.tz(parseInt(this.props.selectedConversation.startTime), this.props.settings.timezone).format("MM/DD/YY, h:mm:ss A zz")}</h6>
            </Col>
          </Row>
        </ListGroupItem>,
        <ListGroupItem key="5" className="px-2">
          <Row>
            <Col>
              <h6>
                {"ANI/Channel Session ID: " + this.props.selectedConversation.channelUserId}
              </h6>
            </Col>
            <Col md="auto"></Col>
            <Col>
            
            {this.props?.selectedConversation?.dnis ? <h6 className="float-right">DNIS: +1{this.props.selectedConversation.dnis}</h6> : <></>}
            </Col>
          </Row>
      </ListGroupItem>,
      <ListGroupItem key="3" className="px-2">
        <Row>
          <Col >
            <h6 className="warnings-header">Warnings:</h6>
            <Badge color={this.getBadgeColor(this.props.selectedConversation.totalErrors)}>{this.props.selectedConversation.totalErrors}</Badge>
          </Col>
        </Row>
      </ListGroupItem>,
      <ListGroupItem key="success" className="px-2">
        <Row>
        <Col  md="6">
          {this.getSuccessStats()}
        </Col>
        <Col  md="6">
       { this.generateLinkedConversationTitle()    }
              {this.generateLinkedConversations()}
        </Col>
        </Row>

      </ListGroupItem>,
        this.props.user.role !== "limited" && this.props.user.role !== "user" &&
        <ListGroupItem key="7" className="px-2">
          <Row className="no-margin-bottom">
            <Col xs="2">
              <h6 className="metadata-heading">
                Tags:
              </h6>
            </Col>
            <Col className="no-padding-left">
              <CreatableSelect
                isMulti
                name="addTags"
                options={this.state.options}
                className="basic-multi-select"
                placeholder="Add tags"
                onChange={this.handleTagSelect}
                value={this.getTags()}
                key={this.state.selectedConversation}
                maxMenuHeight={200}
                backspaceRemovesValue={false}
                onInputChange={this.handleTagInput}
              />
            </Col>
          </Row>
        </ListGroupItem>, this.props.user.role !== "limited" && this.props.user.role !== "user" &&
        <ListGroupItem key="8" className="px-2">
          <Row className="no-margin-bottom">
            <Col xs="2">
              <h6 className="metadata-heading">
                Notes:
              </h6>
            </Col>
            <Col xs="10" className="no-padding-left">
              <InputGroup>
                <Input
                  innerRef={(textInput) => { this.textInput = textInput }}
                  onChange={this.handleChange}
                  value={this.state.comment}
                  type="textarea"
                  name="textarea-input"
                  id="textarea-input"
                  rows="2"
                  maxLength={1024}
                />
              </InputGroup>
              <small className="text-muted mt-1">Maximum 1024 characters allowed</small>
              <ButtonWithAuth
                action="create"
                pathname={this.props.location.pathname}
                color="primary"
                onClick={this.submitComment}
                className="float-right"
                hidden={this.state.hide}
                text="Save"
              >
              </ButtonWithAuth>
            </Col>
          </Row>
        </ListGroupItem>,
        <ListGroupItem key="9" className="px-2">
          <Row className="no-margin-bottom">

            <Col xs="10" className="no-padding-left">
              {this.props.selectedConversation.language === "Spanish" 
              ? <CustomInput type="switch" id="spanishSwitch" name="spanishSwitch" label="Spanish" checked={this.state.isSpanishLanguage} onChange={this.toggleSpanishLanguage} inline/>
              : null}
              
              <Button
                id="copyConversationURL"
                color="primary"
                className="options-button"
                onClick={() => { navigator.clipboard.writeText(apiCalls.getUiUrl() + "/conversations?conversationId=" + this.state.conversationId); }}
              >
                Copy URL
              </Button>
              <Tooltip target="copyConversationURL" trigger="click" isOpen={this.state.copyConversationURL} toggle={this.toggleCopyTooltips}>
                Copied!
              </Tooltip>
              {/* FIX AIMED FOR RELEASE 3.16.0
              <Button
                id="copyConversationDialogue"
                color="primary"
                className="options-button"
                onClick={this.copyConversationDialogue}
              >
                Copy Dialog
              </Button>
              <Tooltip target="copyConversationDialogue" trigger="click" isOpen={this.state.copyConversationDialogue} toggle={this.toggleCopyTooltips}>
                Copied!
              </Tooltip> */}
              
              <ButtonWithAuth
                hidden={!this.openIssuePermitted()}
                key="openIssue"
                action="create"
                pathname={this.props.location.pathname}
                color="primary"
                className="options-button"
                onClick={this.toggleModal2}
                text="Open Issue"
              >
              </ButtonWithAuth>
              {this.generateUnredactedLink()}
            </Col>
          </Row>
        </ListGroupItem>

      ];
    } else {
      return (
        <ListGroupItem>
          <h6 className="no-margin-bottom">
            Select a conversation to view.
          </h6>
        </ListGroupItem>
      );
    }
  }

  handleTagSelect = (value, e) => {
    switch (e.action) {
      case "select-option":
        this.addTagToConversation(e.option.value);
        break;
      case "create-option":
        this.createNewtag(value[value.length - 1].value).then((newTagRes) => {
          this.addTagToConversation(newTagRes.addedTag.TagId);
        })
        break;
      case "remove-value":
        this.deleteTagAttempt(e.removedValue.value);
        break;
      case "clear":
        this.state.conversationTags.forEach(conversationTag => this.deleteTagAttempt(conversationTag.TagId))
        break;
      default:
        break;
    }
  };

  getOptions() {
    let options = this.props.tags ? this.props.tags.map(tag => ({ value: tag.TagId, label: tag.TagName }))
      .sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase() ? 1 : b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 0) : [];
    this.setState({ options: options });
  }

  getTags() {
    return this.state.conversationTags ? this.state.conversationTags.map(conversationTag => ({ value: conversationTag.TagId, label: conversationTag.TagName })) : [];
  }

  deleteTagAttempt(tagId) {
    apiCalls.removeTag(this.props.selectedConversation.conversationId, tagId)
    .then(() => {
      this.getTagsPerConversation();
      return apiCalls.deleteTag(tagId)
        .then(() => { this.props.getTags(); })
        .catch((err) => {})
    })
    .catch(err => {
      this.props.handleAPIError(err);
    })
  }

  getIndex(value, myobj) {
    for (var key of myobj.keys()) {
      if (myobj.get(key) === value) {
        return key;
      }
    }
  }

  createIssue(event) {
    event.preventDefault();
    let emptyIssueSummary = this.state.issueSummary.trim().length === 0,
      longIssueSummary = this.state.issueSummary.length > 100,
      emptyIssueEmailAddress = this.props.settings.issue_email_address && this.props.settings.issue_email_address.trim().length === 0;
    if (!emptyIssueSummary && !longIssueSummary && !emptyIssueEmailAddress) {
      let conversationUrl = apiCalls.getUiUrl() + "/conversations?conversationId=" + this.state.conversationId
      this.setState({ createIssueDisabled: true });
      return apiCalls.createIssue(this.state.issueSummary, this.state.time, this.state.conversationId, this.state.issueSeverity,
        this.state.issueDescription, this.props.settings.projectName, this.props.selectedConversation.channelUserId, this.props.user.username, this.props.settings.issue_email_address,
        conversationUrl)
      .then(result => {
        if (result && result.success) {
          this.toggleModal2();
          this.props.displayToast("Issue created successfully!", "success");
          this.setState({
            issueCreated: true
          });
        }
      })
      .catch(error => {
        this.toggleModal2();
        this.props.handleAPIError(error);
      })
    }
    else {
      this.setState({
        hideEmptyIssueSummaryWarning: !emptyIssueSummary,
        hideLongIssueSummaryWarning: !longIssueSummary,
        hideEmptyIssueEmailAddressWarning: !emptyIssueEmailAddress
      });
    }
  }

  copyConversationDialogue() {
    let conversation = `Conversation ID: ${this.state.conversationId} \n\n`
    if (this.props.messagesData) {
      this.props.messagesData.forEach(message => {
        if (message.agent === "bot") conversation += "Bot: " + message.message + '\n'
        if (message.agent === "user" && message.messageType !== "DTMF") conversation += "Customer: " + message.message + '\n'
      })
    }
    navigator.clipboard.writeText(conversation);
  }

  createNewtag(tag) {
    return apiCalls.newTag(tag)
    .then(result => {
      if (result) {
        this.props.getTags();
        return result;
      }
    })
    .catch(err => {
      this.props.handleAPIError(err);
    })
  }

  addTagToConversation(tag) {
    return apiCalls.addTag(this.props.selectedConversation.conversationId, tag)
    .then(result => {
      if (result && result.success === true) {
        this.getTagsPerConversation();
      }
    })
    .catch(err => {
      this.props.handleAPIError(err);
    })
  }

  togglePartials(e){
    this.setState({
      isPartialsHidden: !this.state.isPartialsHidden
    });
  }

  toggleSpanishLanguage() {
    this.setState({
      isSpanishLanguage: !this.state.isSpanishLanguage
    });
  }
  
  getMessagesRows() {
    if (this.props.messagesData) {
      let trainingPhraseExists = false, count = 1;
      return this.props.messagesData.map((message) => {
        if (this.props.trainingPhraseData && message.message) {
          trainingPhraseExists = this.props.trainingPhraseData.filter((phrase) =>
            message.message.toLowerCase().replace(/[[\]']+/g, '').replace(/ *\([^)]*\) */g, " ") === phrase.TrainingPhraseText.toLowerCase());
        }
        if (message.agent !== "user" || message.message !== "" || message.promptName !== null || message.error !== false || message.type !== null || message.messageType !== null) {
          message.message = message.message.replace(/â€™/g, "'");
          
          return (
            <Message
              {...this.props}
              messageNumber={message.agent === "user" || message.agent === "bot" ? count++ : null}
              isPartialsHidden={this.state.isPartialsHidden}
              addAlertMsg={this.props.addAlertMsg}
              trainingPhraseData={this.props.trainingPhraseData}
              existingPhrase={trainingPhraseExists}
              intentData={this.props.intentData}
              message={message}
              isVoice={this.props.channelName.includes("OMNI_VOICE")}
              refresh={this.props.refresh}
              key={message.messageId}
              versionName={this.props.versionName}
              isSpanishLanguage={this.state.isSpanishLanguage}
            />
          );
        }
      });
    } else if (this.state.conversationId) {
      return(  
        <div className="loadingSpinner">
          <Spinner color="info" />
          </div>)
  }
}

  getTagsPerConversation() {
    if (this.props.selectedConversation !== null && typeof this.props.selectedConversation !== "undefined") {
      return apiCalls.getConversationTags(this.props.selectedConversation.conversationId)
      .then(result => {
        if (result.conversationTags) {
          this.setState({ conversationTags: result.conversationTags });
          this.getOptions();
          this.getTags();
        }
      })
      .catch(error => {
        this.props.handleAPIError(error);
      })
    }
  }

  render() {
    return (
      <div className="inherit-height">
        <Modal size="lg" isOpen={this.state.modal2} toggle={this.toggleModal2} className={this.props.className}>
          <ModalHeader toggle={this.toggleModal2}>Open Issue</ModalHeader>
          <Form
            name="createIssue"
            onSubmit={this.createIssue}
          >
            <ModalBody>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Opened on:</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="createIssueDate"
                    value={this.state.time}
                    disabled={true}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Opened by:</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="createIssueAuthor"
                    disabled={true}
                    value={this.props.user.username}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Severity:</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    name="selectIssuePriority"
                    value={this.state.issueSeverity}
                    onChange={this.handleSeveritySelect}
                    className="severity-margin-right"
                  >
                    {this.getSeverityOptions()}
                  </Input>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Summary:</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="issueSummary"
                    onChange={this.handleSummaryChange}
                  />
                </InputGroup>
                <p hidden={this.state.hideEmptyIssueSummaryWarning} className="warnings-color">The summary cannot be empty</p>
                <p hidden={this.state.hideLongIssueSummaryWarning} className="warnings-color">The summary length cannot exceed 100 characters</p>
              </FormGroup>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Description</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="textarea"
                    name="issueDescription"
                    rows="13"
                    cols="40"
                    onChange={this.handleDescriptionChange}
                  />
                </InputGroup>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
            <p hidden={this.state.hideEmptyIssueEmailAddressWarning} className="mr-auto warnings-color">An email must be provided in the Issues Email field in the settings</p>
              <FormGroup className="form-actions float-right">
                <Button
                  type="submit"
                  action="submit"
                  className="text-right margin-right"
                  color="success"
                  disabled={this.state.createIssueDisabled || !this.state.hideEmptyIssueSummaryWarning || !this.state.hideLongIssueSummaryWarning || !this.state.hideEmptyIssueEmailAddressWarning}
                >
                  Open
                </Button>
                <Button
                  className="text-right"
                  color="secondary"
                  onClick={this.toggleModal2}
                >
                  Cancel
                </Button>
              </FormGroup>
            </ModalFooter>
          </Form>
        </Modal>
        <TabContent id="details" className="details-tab">
          <TabPane className="details-tab-pane">
            <ListGroup className="details-list-group">
              {this.getMetaDataRows()}
              <ListGroup id="messages-list" role="tablist">
                {this.getMessagesRows()}
              </ListGroup>
            </ListGroup>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

export default ConversationDetails;
